import React, { Component, useEffect } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Link from '../utils/link'
import Slider from 'react-slick'
import Fade from 'react-reveal/Fade'
import parse from 'html-react-parser'

class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (<>{this.props.children}</>)
  }
}

const PrevArrow = ({ onClick, style, className }) => {
  let attr = { onClick, style, className }
  return (
    <span
      {...attr}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="10.625" height="20" viewBox="0 0 10.625 20">
        <path d="M9.342-31.777.216-22.527a.751.751,0,0,0,0,1.054l9.126,9.25a.749.749,0,0,0,1.06.007.751.751,0,0,0,.007-1.061L1.8-22l8.606-8.723a.751.751,0,0,0-.007-1.061A.746.746,0,0,0,9.876-32,.747.747,0,0,0,9.342-31.777Z" transform="translate(0 32)" fill="#00D991" />
      </svg>
    </span>
  )
}

const NextArrow = ({ onClick, style, className }) => {
  let attr = { onClick, style, className }
  return (
    <span
      {...attr}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="10.625" height="20" viewBox="0 0 10.625 20">
        <path d="M9.342.223.216,9.473a.751.751,0,0,0,0,1.054l9.126,9.25a.75.75,0,1,0,1.067-1.054L1.8,10l8.606-8.723A.75.75,0,1,0,9.342.223Z" transform="translate(10.625 20) rotate(180)" fill="#00d991" />
      </svg>
    </span>
  )
}

const PageBanner = ({ slides = [], parallax = false, height = 'large' }) => {
  const [index, setIndex] = React.useState(0)
  const [active, setActive] = React.useState(false)

  useEffect(() => {

    setTimeout(() => {
      setActive(true)
    }, 500)

    const onScroll = () => {
      document.querySelectorAll('.page-banner__bg').forEach(el => el.style.transform = `translateY(${window.scrollY * 0.3}px)`)
    }
    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  const settings = {
    speed: 600,
    fade: true,
    autoplay: true,
    autoplaySpeed: 15000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    cssEase: 'ease',
    swipe: false,
    focusOnSelect: false,
    adaptiveHeight: true,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (current, next) => setIndex(next),
  }

  if (!slides?.length) return <div className='page-banner' />

  const { title, content, button } = slides[index]

  let className = 'page-banner'
  if (parallax) className += ' page-banner--parallax'
  if (height === 'small') className += ' page-banner--small'
  if (slides?.length > 1) className += ' page-banner--has-slider'

  return (
    <section className={className}>
      {slides?.length > 1 && (
        <BlockUpdate>
          <Slider {...settings}>
            {slides?.map((el, i) => (
              <div className='page-banner__bg' key={i}>
                {el.video ? <video src={el.video} autoPlay loop muted playsInline /> : <GatsbyImage image={getImage(el.image?.localFile)} alt={title} />}
              </div>
            ))}
          </Slider>
        </BlockUpdate>
      )}

      {slides?.length === 1 &&
        <div className='page-banner__bg'>
          {slides[0].video ? <video src={slides[0].video} autoPlay loop muted playsInline /> : <GatsbyImage image={getImage(slides[0].image?.localFile)} alt={title} />}
        </div>
      }
      <Fade bottom distance={'40px'}>
        <div className='page-banner__inner'>
          <h1 className='page-banner__title'>
            <div className={`page-banner__title-before ${active ? 'active' : ''}`} />
            { title && parse(title) }
            <div className={`page-banner__title-after ${active ? 'active' : ''}`} />
          </h1>
          <div className='page-banner__content'>
            <div className='page-banner__text'>{ content && parse(content) }</div>
            {button?.url &&
              <Link to={button.url} className='page-banner__button btn btn--arrow'>
                <span>{button.title}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="13.675" height="10.262" viewBox="0 0 13.675 10.262">
                  <path d="M16.555,22.112l-.917-.9,3.584-3.584H8v-1.28H19.222l-3.605-3.605.917-.9,5.142,5.142Z" transform="translate(-8 -11.85)" fill="#FFFFFF" />
                </svg>
              </Link>
            }
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default PageBanner